import { getContainerHeight } from "@/Utils/getContainerSize";
import { GetModalContainerHeight } from "@/Utils/StateLib";
import { useEffect, useState } from "react";

export const useModalContainerHeight = (dependencies: any[] = []) => {
  const [containerHeight, setContainerHeight] = useState(getContainerHeight());

  useEffect(() => {
    setContainerHeight(GetModalContainerHeight());
    const handleResize = () => setContainerHeight(GetModalContainerHeight());
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, dependencies);

  return containerHeight;
};
